// Product categories = the shop headings on brugo.in (Tiles, Taps, Lights…). They are separate
// from services (Plumbing, Painting…). Stored in Firestore `product_categories/{slug}`:
//   { name, slug, order, hidden, aliases: [older category names that mean this], created_at, updated_at }
// A product's own heading is `products.shop_category`. Older products without it are matched by
// their `category` through the aliases — exactly what brugo.in does (lib/shopCategories.js).

// brugo.in's current headings + old names, used to seed the list the first time.
export const DEFAULT_PRODUCT_CATEGORIES = [
  ["Bath & Kitchen Accessories", []],
  ["Bolts, Screws & Fasteners", []],
  ["Conduits, Boxes & Fittings", ["Electrical Conduits"]],
  ["Door Hardware, Locks & Handles", ["Door Locks & Hardware"]],
  ["False Ceiling", []],
  ["Fans, Geysers & Invertors", ["Home Appliances & Power Backup"]],
  ["Fevicol & Sealants", ["Fevicol"]],
  ["Hinges & Channels", ["Hinges, Channels & Handles"]],
  ["Kitchen & Wardrobe Hardware", ["Kitchen Systems & Accessories", "Wardrobe & Bed Fittings"]],
  ["Kitchen Sinks & Faucets", []],
  ["MCB, RCCB & DB", []],
  ["Paints, Putty & Sundries", ["Painting", "Paints"]],
  ["Plumbing Pipes, Fittings & Tanks", ["CPVC Pipes & Overhead Tanks", "Overhead Tanks", "PVC Pipes"]],
  ["Plywood, MDF & HDHMR", []],
  ["Sanitary & Bath Fittings", []],
  ["Switches & Sockets", ["Lighting"]],
  ["Tiling, Waterproofing & Cement", ["Tiling", "Waterproofing", "Cement"]],
  ["Tools & Accessories", ["General Hardware & Tools"]],
  ["Wires & Cables", ["Wires, MCB & Distribution Boards"]],
  ["Diwali Lighting", []],
];

export const slugOf = (name) => String(name || "").toLowerCase().replace(/&/g, "and").replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "").slice(0, 60) || "category";
export const sortCats = (a, b) => (a.order ?? 999) - (b.order ?? 999) || String(a.name).localeCompare(String(b.name));

// Which product category a product belongs to (null = none yet).
export function productCategoryOf(p = {}, cats = []) {
  const byName = new Map(cats.map((c) => [String(c.name).toLowerCase(), c.name]));
  const own = String(p.shop_category || "").toLowerCase();
  if (own && byName.has(own)) return byName.get(own);
  const cat = String(p.category || p.category_name || "").trim().toLowerCase();
  if (cat && byName.has(cat)) return byName.get(cat);
  const hit = cats.find((c) => (c.aliases || []).some((a) => String(a).toLowerCase() === cat));
  return hit ? hit.name : null;
}
